import { FC } from "react";

export const AnalysisPlaceholder: FC<{ message: string }> = ({ message }) => (
  <p className="py-4 text-sm text-gray-400 dark:text-neutral-500">{message}</p>
);
